import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import {
  type PortalTabbedNavigationTab,
  TabbedNavigationGroup,
} from '../../../../../../../../../../../../components/router/router-tabbed-navigation';
import { PortfolioTransactionsTable } from '../../../../../../../../../../../../features/portfolio/transaction/portfolio-transactions-table';
import { AccountPortfolioAssetBalanceHeader } from '../../../../../../../../../../../../features/registration/account/account-portfolio-asset-balance-header';
import type { ViewContext } from '../../../../../../../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/asset/_asset/$assetId/_asset-balance/')({
  component: AccountAssetTransactionList,
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RegistrationAccountPortfolioAssetBalance,
      label: 'Transactions',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.RegistrationAccountPortfolioAssetBalance>,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const { accountId, assetId } = Route.useParams();
  return <AccountPortfolioAssetBalanceHeader accountId={accountId} assetId={assetId} filter={filter} />;
}

function AccountAssetTransactionList() {
  const { accountId, assetId } = Route.useParams();
  const viewContext = useMemo(
    () =>
      ({
        kind: 'account',
        accountId,
      }) as const satisfies ViewContext,
    [accountId],
  );

  return (
    <PageLayout.Section noBorder>
      <PortfolioTransactionsTable assetId={assetId} HeaderActions={TableHeader} view={viewContext} />
    </PageLayout.Section>
  );
}
